export default {
  ELI_MAIN: 'Main',
  ELI_SYMBOL: 'movieClips/symbols/symbol',
  ELI_BIG_REEL: 'movieClips/slot/bigReel',
  ELI_OVERLAY: 'movieClips/overlay/overlay',
}
